'use strict';

var PropTypes = require('prop-types');
var React = require('react');
var createReactClass = require('create-react-class');
var mapG = {},
    mapOptionsG = {};
var markersG = {};
var _ = require('lodash');
var LocalizeMixin = require('../../../localization/CommonLocalizationMixin');

var MapCanvas = createReactClass({
    displayName: 'MapCanvas',
    mixins: [LocalizeMixin],

    propTypes: {
        initialZoom: PropTypes.number,
        disableDefaultUi: PropTypes.bool,
        mapCenter: PropTypes.shape({
            lat: PropTypes.number,
            lng: PropTypes.number
        })
    },

    getDefaultProps: function getDefaultProps() {
        return {
            locations: []
        };
    },

    getInitialState: function getInitialState() {
        return { markersLocationIdMap: {} };
    },

    getMarkerMapImage: function getMarkerMapImage(google, color) {
        return {
            url: '/images/common/icons/ic_pin_' + color + '.png', // url
            scaledSize: new google.maps.Size(27, 37), // scaled size
            origin: new google.maps.Point(0, 0), // origin
            anchor: new google.maps.Point(14, 37) // anchor
        };
    },


    componentDidMount: function componentDidMount() {
        var self = this;
        window.wendysGlobal = {
            handleOrderClickFromMap: function handleOrderClickFromMap(id) {
                var location = _.find(self.props.locations, { id: id });
                self.props.locationSelectHandler({
                    type: 'order',
                    location: location
                });
            },
            handleNotifyClickFromMap: function handleNotifyClickFromMap(id) {
                var location = _.find(self.props.locations, { id: id });
                self.props.locationSelectHandler({
                    type: 'notify',
                    location: location
                });
            }
        };

        mapOptionsG[this.props.refName] = {
            center: this.props.mapCenter || { lat: 40.316084, lng: -96.067057 },
            zoom: this.props.initialZoom || 4,
            scrollwheel: false,
            draggable: !this.props.disableDefaultUi,
            disableDefaultUI: this.props.disableDefaultUi,
            disableDoubleClickZoom: this.props.disableDefaultUi,
            fullscreenControl: false,
            backgroundColor: "#EFEBE9"
        };

        mapG[this.props.refName] = new this.props.googleMapsHelper.googleMapsInstance.maps.Map(this.refs[this.props.refName], mapOptionsG[this.props.refName]);
        markersG[this.props.refName] = [];

        this.mapLoaded();

        if (this.props.locations) {
            this.props.locations.forEach(function (v, k) {
                var pos = new self.props.googleMapsHelper.googleMapsInstance.maps.LatLng(v.location.lat, v.location.lon);
                if (k === 0) {
                    mapG[self.props.refName].panTo(pos);
                }

                markersG[self.props.refName].push(new self.props.googleMapsHelper.googleMapsInstance.maps.Marker({
                    position: pos,
                    map: mapG[self.props.refName],
                    icon: self.getMarkerMapImage(self.props.googleMapsHelper.googleMapsInstance, 'red')
                }));
            });
        }
        if (this.props.isInModal) {
            this.componentWillReceiveProps(this.props);
        }
    },

    componentWillUnmount: function componentWillUnmount() {
        window.wendysGlobal = false;
    },

    mapLoaded: function mapLoaded() {
        if (this.props.mapLoaded) {
            this.props.mapLoaded();
        }
    },

    render: function render() {
        return React.createElement('div', { ref: this.props.refName, className: 'map-canvas' });
    },

    handleMapLocationSelect: function handleMapLocationSelect(v, programmaticallyCalled) {
        if (this.props.handleMapLocationSelect) {
            this.props.handleMapLocationSelect(v, programmaticallyCalled);
        }
    },

    isMobileResolution: function isMobileResolution() {
        if (document.getElementById('is-screen-resolution-xs')) {
            return window.getComputedStyle(document.getElementById('is-screen-resolution-xs')).fontWeight == 100;
        } else {
            return false;
        }
    },

    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        var self = this;
        var centerOn;

        if (self.props.selectedLocationId !== nextProps.selectedLocationId && !self.props.isInModal) {
            var marker = self.state.markersLocationIdMap[nextProps.selectedLocationId];
            if (marker) {
                self.props.googleMapsHelper.googleMapsInstance.maps.event.trigger(marker, 'click', { locationSelectedWithEnter: nextProps.locationSelectedWithEnter });
            }
        } else if (!_.isEqual(self.props.locations, nextProps.locations)) {
            // TODO: refactor this conditional block into smaller, self defining routines
            var infoWindow = new self.props.googleMapsHelper.googleMapsInstance.maps.InfoWindow();
            var markersLocationIdMap = {};
            markersG[self.props.refName].forEach(function (v) {
                v.setMap(null);
            });
            markersG[self.props.refName] = [];
            1;
            nextProps.locations.forEach(function (v, k) {
                var pos = new self.props.googleMapsHelper.googleMapsInstance.maps.LatLng(v.location.lat, v.location.lon);
                if (k === 0) {
                    centerOn = pos;
                    if (mapG[self.props.refName].zoom == 4) {
                        //if map has initial zoom level zoom in, but only if its at initial zoom level
                        mapG[self.props.refName].setZoom(15);
                    }
                    mapG[self.props.refName].panTo(pos);
                }

                var image = self.getMarkerMapImage(google, v.hasMobileOrder ? 'blue' : 'brown');

                var selectedImage = self.getMarkerMapImage(google, 'red');

                var marker = new self.props.googleMapsHelper.googleMapsInstance.maps.Marker({
                    position: pos,
                    map: mapG[self.props.refName],
                    icon: image,
                    hasMobileOrder: v.hasMobileOrder
                });

                self.props.googleMapsHelper.googleMapsInstance.maps.event.clearListeners(marker, 'click');
                self.props.googleMapsHelper.googleMapsInstance.maps.event.addListener(marker, 'click', function (e) {
                    var latLng = v.location.lat + ',' + v.location.lon;
                    var url = 'https://www.google.com/maps/dir/Current+Location/' + latLng;
                    var makeTextSmaller = self.props.lang == "es" ? "make-text-smaller" : "";
                    var phone = '';
                    if (v.phone && _.isString(v.phone)) {
                        phone = '(' + v.phone.substring(0, 3) + ') ' + v.phone.substring(3, 6) + '-' + v.phone.substring(6, 10);
                    }

                    markersG[self.props.refName].forEach(function (m) {
                        image = self.getMarkerMapImage(google, m.hasMobileOrder ? 'blue' : 'brown');
                        m.setIcon(image);
                    });
                    marker.setIcon(selectedImage);

                    function buildAmenitiesIcon(imageName, active, text) {
                        return '<div class="inline">\n                            <img src="/images/common/amenities/ic_brown_' + imageName + '_' + (active ? "normal" : "disabled") + '.png"\n                                role="icon" alt="' + (active ? text : '') + '" />\n                            <span class="toolTip" aria-hidden="true">' + text + '</span>\n                        </div>';
                    }

                    if (!self.props.disableDefaultUi) {
                        var content = '\n                            <div class=\'map-popup\'>\n                                <div class="ada-map-focus-content" tabindex="0" style="overflow: hidden; margin: 10px 10px 0 0;">\n                                    <h2 class=\'marker-title\'>' + v.title + '</h2>\n                                    <p class=\'marker-p\'/>' + v.address1 + '</p>\n                                    <p class=\'marker-p\'>' + v.address2 + '</p>\n                                    <p class=\'marker-p\'>' + phone + '</p>\n                                    <p class=\'marker-hours\'>' + self.getLocalizedText('location_page_open_today') + ': ' + v.hours + '</p>\n                                    <p class=\'marker-amenities\'>\n                                        <div class=\'amenities-container\'>' + (buildAmenitiesIcon('mobile', v.hasMobileOrder, self.getLocalizedText('amenities_mobile_order')) + buildAmenitiesIcon('mobilepay', v.hasMobilePay, self.getLocalizedText('amenities_mobile_pay')) + buildAmenitiesIcon('wifi', v.hasWifi, self.getLocalizedText('amenities_wifi')) + buildAmenitiesIcon('late', v.isOpenLate, self.getLocalizedText('amenities_open_late')) + buildAmenitiesIcon('always_open', v.isOpen24Hours, self.getLocalizedText('amenities_always_open')) + buildAmenitiesIcon('breakfast', v.hasBreakfast, self.getLocalizedText('amenities_breakfast')) + buildAmenitiesIcon('freestyle', v.hasCokeFreestyle, self.getLocalizedText('amenities_freestyle'))) + '</div>\n                                    <p>\n                                </div>\n                                <div class=\'row\'><div>\n                        ';
                        if (v.hasMobileOrder) {
                            content += '<p><input type="button" class="btn btn-primary order-btn ' + makeTextSmaller + '" value="' + self.getLocalizedText('order_buttons_order_here') + '" onClick="window.wendysGlobal.handleOrderClickFromMap(\'' + v.id + '\');" />';
                        }
                        content += '<p class="map_info_link"><a href=' + url + ' target="_blank" id="get-directions-' + v.id + '">' + self.getLocalizedText('find_buttons_get_directions') + '</a></p></div>';
                        content += "</div></div>";

                        var eventCallbackFn = function eventCallbackFn() {
                            /* the 'x' close button is dynamically added by Google via the API: manipulate (move and assign attrs/class) to add to the tab events */
                            $('.gm-style-iw').next('div').attr({ 'tabindex': '3' }).addClass('info-window-close').appendTo($('.map-popup'));
                            var parent = document.getElementsByClassName('map-popup')[0].parentElement.parentElement.parentElement.parentElement;
                            parent.className = "hidden-xs";
                            self._addEventListenersToinfoWindowPopUp(parent, self, v, e);
                        };
                        self.props.googleMapsHelper.googleMapsInstance.maps.event.clearListeners(infoWindow, 'domready');
                        self.props.googleMapsHelper.googleMapsInstance.maps.event.addListener(infoWindow, 'domready', eventCallbackFn);

                        infoWindow.setContent(content);
                        infoWindow.open(mapG[self.props.refName], marker);
                        if (self.isMobileResolution()) {
                            infoWindow.close(mapG[self.props.refName], marker);
                        }
                    }
                    mapG[self.props.refName].panTo(pos);
                    if (_.isUndefined(e.locationSelectedWithEnter)) {
                        //only trigger location select if pin is clicked
                        self.handleMapLocationSelect(v);
                    }
                });

                markersG[self.props.refName].push(marker);
                markersLocationIdMap[v.id] = marker;
            });

            self.setState({ markersLocationIdMap: markersLocationIdMap });
        }

        self._centerMapOnLocation(self, nextProps, centerOn);
    },

    /**
     * Positioning of Map based on locations
     * @param scope
     * @param nextProps
     * @param centerOnProperty
     * @private
     */
    _centerMapOnLocation: function _centerMapOnLocation(scope, nextProps, centerOnProperty) {
        var centerOn = centerOnProperty;
        var selectedLocation = _.find(nextProps.locations, { id: nextProps.selectedLocationId }) || null;

        if (nextProps.locations.length) {
            centerOn = selectedLocation ? new scope.props.googleMapsHelper.googleMapsInstance.maps.LatLng(selectedLocation.location.lat, selectedLocation.location.lon) : new scope.props.googleMapsHelper.googleMapsInstance.maps.LatLng(nextProps.locations[0].location.lat, nextProps.locations[0].location.lon);
        }

        if (centerOn) {
            //checks if nothing is selected and the map is showing or if something is selected but its not in the search results
            if (!selectedLocation && !scope.props.disableDefaultUi && nextProps.locations.length && (!this.isMobileResolution() || nextProps.mapShowing)) {
                scope.handleMapLocationSelect(nextProps.locations[0], true);
                mapG[nextProps.refName].panTo(centerOn);
            }
            scope.props.googleMapsHelper.googleMapsInstance.maps.event.trigger(mapG[nextProps.refName], 'resize');
            if (nextProps.isInModal) {
                $('#generic-modal').on('shown.bs.modal', function (e) {
                    scope.props.googleMapsHelper.googleMapsInstance.maps.event.trigger(mapG[nextProps.refName], 'resize');
                    mapG[nextProps.refName].setZoom(15);
                    mapG[nextProps.refName].panTo(centerOn);
                    $('#generic-modal').unbind('shown.bs.modal');
                });
                if (markersG[nextProps.refName].length) {
                    markersG[nextProps.refName][0].setIcon(scope.getMarkerMapImage(google, 'red'));
                }
                mapG[nextProps.refName].panTo(centerOn);
            }
            //center no matter what if there is a selected locatuon and map is being shown on mobile break point.
            if (!scope.props.mapShowing && nextProps.mapShowing) {
                mapG[scope.props.refName].panTo(centerOn);
            }
        }
    },

    /**
     * Event Listener Callback assigned to the infoWindow Pop Up
     * @param parent
     * @param scope
     * @param v
     * @param parentEvent
     * @private
     */
    _addEventListenersToinfoWindowPopUp: function _addEventListenersToinfoWindowPopUp(parent, scope, v, parentEvent) {
        parent.addEventListener('keydown', function (e) {
            var setFocusTargetToCloseButton = e.target.className.match(/ada-map-focus-content/) && e.shiftKey || e.target.id === 'get-directions-' + v.id && !e.shiftKey;

            /* escape key returns focus to selected location distance */
            scope._infoWindowEvents.onEsc(e, v);

            /* enter key event if close button is current selection  */
            scope._infoWindowEvents.onEnter(e, v);

            /* tab key event: trap event to infoWindow */
            scope._infoWindowEvents.onTab(e, v, setFocusTargetToCloseButton);
        });

        if (parentEvent.locationSelectedWithEnter) {
            //for ADA, will focus on popup if location selected
            // need to settimeout here because otherwise focus will revert immediately after setting it
            window.setTimeout(function () {
                return document.querySelector('.ada-map-focus-content').focus();
            }, 50);
        }
    },

    /**
     * event methods we have attached to the
     * Google Maps infoWindow to trap tabbing
     * and focus to the infoWindow
     */
    _infoWindowEvents: {
        /**
         * ESC key event handler
         * @param event
         * @param currentLocation
         */
        onEsc: function onEsc(event, currentLocation) {
            /* escape key returns focus to selected location distance */
            if (event.keyCode === 27) {
                document.querySelector('#find-distance-' + currentLocation.id).focus();
            }
        },

        /**
         * Enter Key event handler
         * @param event
         * @param currentLocation
         */
        onEnter: function onEnter(event, currentLocation) {
            var closeEnabled = event.target.className.match(/info-window-close/);

            /* enter key event if close button is current selection  */
            if (event.keyCode === 13 && closeEnabled) {
                $('div.info-window-close').click();
                document.querySelector('#find-distance-' + currentLocation.id).focus();
            }
        },

        /**
         * Tab key event handler
         * @param event
         * @param currentLocation
         * @param setFocusTargetToCloseButton
         */
        onTab: function onTab(event, currentLocation, setFocusTargetToCloseButton) {
            if (event.keyCode === 9) {

                /* change focus to close button from next or previous (shift+tab) element */
                if (setFocusTargetToCloseButton) {
                    event.preventDefault();
                    event.stopPropagation();
                    $('div.info-window-close').focus();
                }

                /* set focus when tabbing off of close button to next or previous (shift+tab) element */
                if (event.target.className.match(/info-window-close/)) {
                    if (event.shiftKey) {
                        event.preventDefault();
                        event.stopPropagation();
                        document.querySelector('#get-directions-' + currentLocation.id).focus();
                    } else {
                        event.preventDefault();
                        event.stopPropagation();
                        document.querySelector('.ada-map-focus-content').focus();
                    }
                }

                /* set focus when tabbing off of order here button to force to get directions element (for Firefox) */
                if (event.target.className.match(/order-btn/)) {
                    if (!event.shiftKey) {
                        event.preventDefault();
                        event.stopPropagation();
                        document.querySelector('#get-directions-' + currentLocation.id).focus();
                    }
                }
            }
        }
    }
});

module.exports = MapCanvas;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/findLocationComponents/search/MapCanvas.js
// module id = 210
// module chunks = 0